import type { MessageAttachment } from '@wix/ai-scheduling-assistant-common-lib/entities';

/**
 * A file ANNOUNCED before it exists: the agent attaches this while a design is being generated, so the
 * reply shows the files arriving, and replaces it with the real asset when that lands (the harness's
 * AttachFile, through the `attachments` mask of UpdateConversationMessage). It carries a name and a type
 * and NEITHER address, which is what identifies it — there is no flag for anything to disagree with.
 *
 * The swap reaches an open chat on the ASSISTANT_CHAT push that already delivers attachments to a
 * streamed bubble (`patchAttachmentsById`), so nothing here has to poll or refetch.
 *
 * Kept as its own module rather than shared from common-lib, and duplicated in the harness and both
 * phones, the way `file-record` is: it is two comparisons, and each surface expresses them in its own
 * language anyway.
 */
export function isPlaceholderAttachment(attachment: Pick<MessageAttachment, 'url' | 'vfsPath'>): boolean {
  return !attachment.url?.trim() && !attachment.vfsPath?.trim();
}

/**
 * A picture on the AGENT's side keeps the exact box its skeleton reserved — live, when it replaces the
 * placeholder, and on every later load — so the two are always one size and the swap is a pure
 * cross-fade. The side is the signal, because the filled attachment itself carries no mark: the harness
 * writes it back as a plain permanent URL, the same shape as an uploaded photo. A photo the user sent
 * keeps its own aspect, because nothing reserved a box for it.
 */
export function fillsReservedBox(mimeType: string, agentAuthored: boolean): boolean {
  return agentAuthored && mimeType.startsWith('image/');
}
